module.exports = __webpack_public_path__ + "736dffa00cb8526472eac1034d686615.svg";